import ListEnum from '../../enumerators/list.enum'

export default class SharePdfComponent {
    constructor() {
        SharePdfComponent.sharePdf()
    }

    static sharePdf() {
        document.addEventListener('show.hc.modal', () => {
            $(ListEnum.LIST_SHARE_PDF).off('click')
            $(ListEnum.LIST_SHARE_PDF).on('click', () => {
                const url = new URL(window.location.href)
                url.searchParams.append('sitpdf', 1)
                window.open(url.href, '_blank')
            })
        })
    }
}
